import React, { createContext, useContext } from "react";

interface DrawerContextType {
  open: boolean;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const DrawerProvider: React.FC<{ children: React.ReactNode; open: boolean }> = ({
  children,
  open,
}) => {
  return (
    <DrawerContext.Provider value={{ open }}>
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawerContext must be used within a DrawerProvider");
  }
  return context;
};
